/**
 * Avatar initials for a founder/workspace name: first + last initial (e.g.
 * "Jane Doe" → "JD"), falling back to the first two letters for a single word
 * and "?" when empty. Shared by the founder cards (doer home) and the workspace
 * switcher so they render identical avatars for the same founder.
 *
 * Note: this intentionally differs from the generic `getInitials` util, which
 * uses the first two words rather than first + last.
 */
export function founderInitials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
